import { Group, GroupListing } from "../../types";
import axios from "../axios";

export const createGroup = async (entityId: number, body: any): Promise<Group> => {
  try {
    const response = await axios.post<Group>(`/api/${entityId}/groups`, body);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const getGroupsList = async (entityId: number | null): Promise<GroupListing[] | undefined> => {
  try {
    if (!entityId) return;

    const response = await axios.get<GroupListing[]>(`/api/${entityId}/groups`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const getGroupDetails = async (entityId: number | null, groupId: string | undefined): Promise<any> => {
  if (!groupId || !entityId) return;

  try {
    const response = await axios.get<Group>(`/api/${entityId}/groups/${groupId}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to get group details");
  }
};

export const updateGroupDetails = async (
  entityId: number | null,
  groupId: string | undefined,
  body: any
): Promise<any> => {
  if (!groupId || !entityId) return;
  try {
    const response = await axios.put<Group>(`/api/${entityId}/groups/${groupId}`, body);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to get group details");
  }
};

export const removeUserFromGroup = async (
  entityId?: number | null,
  groupId?: string,
  userId?: number
): Promise<any> => {
  if (!groupId || !entityId || !userId) return;

  try {
    const response = await axios.delete<Group>(`/api/${entityId}/groups/${groupId}/users/${userId}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to get group details");
  }
};
